import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const TermsOfService = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Условия использования
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" gutterBottom>
          Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
        </Typography>
        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            1. Введение
          </Typography>
          <Typography variant="body1" paragraph>
            Добро пожаловать на сайт DomikTyumen. Используя наш сайт и сервисы, вы соглашаетесь с настоящими Условиями использования. Пожалуйста, внимательно прочитайте их перед использованием нашего сайта.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            2. Определения
          </Typography>
          <Typography variant="body1" paragraph>
            "Сайт" - веб-сайт DomikTyumen, доступный по адресу domiktyumen.ru.
          </Typography>
          <Typography variant="body1" paragraph>
            "Пользователь" - любое лицо, которое использует Сайт.
          </Typography>
          <Typography variant="body1" paragraph>
            "Услуги" - услуги бронирования загородных домов и коттеджей, предоставляемые через Сайт.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            3. Регистрация и учетная запись
          </Typography>
          <Typography variant="body1" paragraph>
            Для использования некоторых функций Сайта вам может потребоваться создать учетную запись. При регистрации вы должны предоставить точную и полную информацию (имя, номер телефона и email адрес) и поддерживать ее актуальность.
          </Typography>
          <Typography variant="body1" paragraph>
            Вы несете ответственность за сохранение конфиденциальности вашего пароля и за все действия, которые происходят под вашей учетной записью. Вы должны немедленно уведомить нас о любом несанкционированном использовании вашей учетной записи.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            4. Бронирование и оплата
          </Typography>
          <Typography variant="body1" paragraph>
            Бронирование через наш Сайт подлежит подтверждению. Мы оставляем за собой право отказать в бронировании по любой причине.
          </Typography>
          <Typography variant="body1" paragraph>
            Цены на услуги указаны на Сайте и могут быть изменены без предварительного уведомления. Все платежи обрабатываются через безопасные платежные системы.
          </Typography>
          <Typography variant="body1" paragraph>
            Политика отмены бронирования указана на странице каждого объекта размещения. Пожалуйста, ознакомьтесь с ней перед бронированием.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            5. Правила поведения пользователей
          </Typography>
          <Typography variant="body1" paragraph>
            При использовании нашего Сайта вы соглашаетесь не:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Нарушать любые применимые законы или правила</li>
            <li>Использовать Сайт способом, который может повредить, отключить, перегрузить или нарушить работу Сайта</li>
            <li>Пытаться получить несанкционированный доступ к системам или сетям, связанным с Сайтом</li>
            <li>Собирать или хранить персональные данные других пользователей без их согласия</li>
            <li>Размещать или передавать любой незаконный, угрожающий, клеветнический, оскорбительный или иной неприемлемый материал</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            6. Интеллектуальная собственность
          </Typography>
          <Typography variant="body1" paragraph>
            Все содержимое Сайта, включая тексты, графику, логотипы, изображения, а также их подборка и расположение, является интеллектуальной собственностью DomikTyumen или наших лицензиаров и защищено законами об авторском праве.
          </Typography>
          <Typography variant="body1" paragraph>
            Вы не имеете права копировать, воспроизводить, распространять, публиковать, отображать, изменять или создавать производные работы на основе любого содержимого Сайта без нашего предварительного письменного разрешения.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            7. Ограничение ответственности
          </Typography>
          <Typography variant="body1" paragraph>
            Мы стремимся обеспечить точность и актуальность информации на нашем Сайте, но не гарантируем, что содержимое Сайта будет свободно от ошибок или упущений.
          </Typography>
          <Typography variant="body1" paragraph>
            В максимальной степени, разрешенной законом, мы не несем ответственности за любые прямые, косвенные, случайные, специальные или штрафные убытки, возникающие в результате использования или невозможности использования нашего Сайта или услуг.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            8. Email рассылка
          </Typography>
          <Typography variant="body1" paragraph>
            При регистрации на Сайте вы автоматически подписываетесь на email рассылку с новостями, специальными предложениями и информацией о наших услугах. Вы можете в любое время отказаться от получения рассылки через настройки вашего профиля в разделе "Подписки".
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            9. Изменения в условиях использования
          </Typography>
          <Typography variant="body1" paragraph>
            Мы можем изменять настоящие Условия использования в любое время, публикуя обновленную версию на этой странице. Продолжая использовать Сайт после внесения таких изменений, вы соглашаетесь с обновленными Условиями использования.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            9. Применимое право
          </Typography>
          <Typography variant="body1" paragraph>
            Настоящие Условия использования регулируются и толкуются в соответствии с законодательством Российской Федерации. Любые споры, возникающие в связи с настоящими Условиями использования, подлежат рассмотрению в судах Российской Федерации.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom>
            10. Контактная информация
          </Typography>
          <Typography variant="body1" paragraph>
            Если у вас есть вопросы или предложения относительно наших Условий использования, пожалуйста, свяжитесь с нами:
          </Typography>
          <Typography variant="body1">
            Email: admin@domik72.ru
          </Typography>
          <Typography variant="body1">
            Телефон: +7 (963) 060-02-55
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService;
